import { gql as t } from "@apollo/client";
const c = t`
  fragment PublicAccount on PublicAccount {
    avatar
    name
    tag
    walletAddress
  }
`, n = t`
  fragment Account on Account {
    id
    avatar
    name
    tag
    email
    emailNotification {
      enableAssetSold
      enableGameUpdates
      enableMarketingEvent
    }
    walletAddress
  }
`, e = t`
  fragment BattlePass on BattlePass {
    isStartGameDemo
    booty {
      total
      used
    }
  }
`, o = t`
  fragment Mint on Mint {
    apostle {
      reserveSlots
      freeTotal
      freeUsed
      paidUsed
    }
  }
`, s = t`
  fragment GameInfo on AccountGameInfo {
    battlePass {
      ...BattlePass
    }
    mint {
      ...Mint
    }
  }

  ${e}
  ${o}
`, a = t`
  fragment Invitation on AccountInvitation {
    invitationCode
    inviteeCount
    inviterAccountID
  }
`, r = t`
  fragment PublicInvitation on PublicAccountInvitation {
    invitationCode
    inviteeCount
    inviterAccountID
  }
`, l = t`
  fragment LoginAccount on LoginAccountPayload {
    account {
      ...Account
    }
    accountInvitation {
      ...Invitation
    }
    accessToken
    refreshToken
    isNewAccount
  }

  ${n}
  ${a}
`, m = t`
  fragment VipLevel on VipLevelOutput {
    level
    progress
    nextLevelPoint
  }
`;
export {
  n as AccountFragment,
  s as GameInfoFragment,
  a as InvitationFragment,
  l as LoginAccountFragment,
  c as PublicAccountFragment,
  r as PublicInvitationFragment,
  m as VipLevelFragment
};
//# sourceMappingURL=account.js.map
